import moment from "moment/moment";
import { useEffect, useState } from "react";
import CardHeaderDashboard from "./cardHeaderDashboard";
import { GetConnMC, GetKKCinfo } from "../../api";
import CardHeaderDashboardOnOff from "../utils/cardHeaderDashboardOnOff";
import { Button } from 'primereact/button';
import { MainAreaHeader } from "../layout/MainArea";



// auth-user.alter.ficom-it.info
// test-incident-resolve.alter.ficom-it.info
// use-info-systems.alter.ficom-it.info

const CardSystems = (props) => {
  const token = localStorage.getItem('token')

  const [loading, setLoading] = useState(false);
  const [stateKKC, setStateKKC] = useState()
  const [status, setStatus] = useState();
  const [date, setDate] = useState();
  const [loadingStatus, setLoadingStatus] = useState(true)

  let servicesPrev = [
    { id: 1, name: "Локальная система навигации в целом", status: status, is_used: status},
    { id: 2, name: "Пункт управления ПУ-ЛСН", status: status, is_used: status},
    { id: 3, name: "Контрольно-корректирующая станция", status: status, is_used: status},
    { id: 4, name: "Многофункциональная станция (комплект 1)", status: status, is_used: status},
    { id: 5, name: "Многофункциональная станция (комплект 2)", status: status, is_used: status},
    { id: 6, name: "Многофункциональная станция (комплект 3)", status: status, is_used: status},
    { id: 7, name: "Многофункциональная станция (комплект 4)", status: status, is_used: status},
];
const [servicesMC, setServicesMC] = useState(servicesPrev)
 useEffect(() => {
            window.timer = setInterval(async () => {
              let arr = []
              let num = 4
              arr.push({id: 2, name: `Пункт управления ПУ-ЛСН`, status: "normal", is_used: "normal", date: (new Date()).toUTCString(), href: 'msdata'})
             await  GetKKCinfo(token, 0, 1).then((e) => {
                setStateKKC(e.data.data[0])
                arr.push({id: 3, name: `Контрольно-корректирующая станция`, status: e.data.data[0].status, is_used: e.data.data[0].status, date: (new Date()).toUTCString(), href: 'msdata'})
              })
              await GetConnMC(token, 0, 1).then((e) => {
                      for (let index = 0; index < e.data.data[0].psats.length; index++) {
                          const element = e.data.data[0].psats[index];
                          arr.push({id: num + 1, name: `Многофункциональная станция (комплект ${index + 1})`, status: element.status, is_used: element.is_used ? "normal" : "failed", date: (new Date()).toUTCString(), href: 'msdata'})
                          num = num + 1
                      }
                      setLoadingStatus(false)
                    }).catch(() => {
                      setLoadingStatus(false)
                      clearInterval(window.timer);
                    })
                    arr.unshift({id: 1, name: `Локальная система навигации в целом`, status: (arr[0].status === "normal" && arr[1].status === "normal" && arr[2].status === "normal" && arr[3].status === "normal" && arr[4].status === "normal" && arr[5].status === "normal") ? "normal" : arr[0].status === "normal" && arr[1].status === "normal" &&  ((arr[2].status === "failed" ||  arr[2].status === "missing") || (arr[3].status === "failed" ||  arr[3].status === "missing") || (arr[4].status === "failed" ||  arr[4].status === "missing") || (arr[5].status === "failed" ||  arr[5].status === "missing")) ? undefined : "failed" , is_used: (arr[0].is_used === "normal" && arr[1].is_used === "normal" && arr[2].is_used === "normal" && arr[3].is_used === "normal" && arr[4].is_used === "normal" && arr[5].is_used === "normal") ? "normal" : arr[0].is_used === "normal" && arr[1].is_used === "normal" &&  ((arr[2].is_used === "failed" ||  arr[2].is_used === "missing") || (arr[3].is_used === "failed" ||  arr[3].is_used === "missing") || (arr[4].is_used === "failed" ||  arr[4].is_used === "missing") || (arr[5].is_used === "failed" ||  arr[5].is_used === "missing")) ? undefined : "failed" , date: (new Date()).toUTCString(), href: 'msdata'})
                    setServicesMC(arr)
                  }, 30000);
                }, [])
                
    const handleClick =  async(event) => {
      if (loading) return;
      event && event.preventDefault();
      event && event.target.blur();
      setLoading(true);

      let arr = []
      let num = 4
      arr.push({id: 2, name: `Пункт управления ПУ-ЛСН`, status: "normal", is_used: "normal", date: (new Date()).toUTCString(), href: 'msdata'})
     await  GetKKCinfo(token, 0, 1).then((e) => {
        setStateKKC(e.data.data[0])
        arr.push({id: 3, name: `Контрольно-корректирующая станция`, status: e.data.data[0].status, is_used: e.data.data[0].status, date: (new Date()).toUTCString(), href: 'msdata'})
      })
      await GetConnMC(token, 0, 1).then((e) => {
              for (let index = 0; index < e.data.data[0].psats.length; index++) {
                  const element = e.data.data[0].psats[index];
                  arr.push({id: num + 1, name: `Многофункциональная станция (комплект ${index + 1})`, status: element.status, is_used: element.is_used ? "normal" : "failed", date: (new Date()).toUTCString(), href: 'msdata'})
                  num = num + 1
              }
              setLoadingStatus(false)
            }).catch(() => {
              setLoadingStatus(false)
              clearInterval(window.timer);
            })
            
            arr.unshift({id: 1, name: `Локальная система навигации в целом`, status: (arr[0].status === "normal" && arr[1].status === "normal" && arr[2].status === "normal" && arr[3].status === "normal" && arr[4].status === "normal" && arr[5].status === "normal") ? "normal" : arr[0].status === "normal" && arr[1].status === "normal" &&  ((arr[2].status === "failed" ||  arr[2].status === "missing") || (arr[3].status === "failed" ||  arr[3].status === "missing") || (arr[4].status === "failed" ||  arr[4].status === "missing") || (arr[5].status === "failed" ||  arr[5].status === "missing")) ? undefined : "failed" , is_used: (arr[0].is_used === "normal" && arr[1].is_used === "normal" && arr[2].is_used === "normal" && arr[3].is_used === "normal" && arr[4].is_used === "normal" && arr[5].is_used === "normal") ? "normal" : arr[0].is_used === "normal" && arr[1].is_used === "normal" &&  ((arr[2].is_used === "failed" ||  arr[2].is_used === "missing") || (arr[3].is_used === "failed" ||  arr[3].is_used === "missing") || (arr[4].is_used === "failed" ||  arr[4].is_used === "missing") || (arr[5].is_used === "failed" ||  arr[5].is_used === "missing")) ? undefined : "failed" , date: (new Date()).toUTCString(), href: 'msdata'})
            setDate(Date.now())
            setServicesMC(arr)
      setTimeout(() => {
        setLoading(false);
      }, 1000);
  }
console.log("servicesMC",servicesMC);




  useEffect(() => {
    handleClick()
  }, [])

 
  // useAsyncEffect(() => {
  //   getOrdersClientByID(token, urlSearch?.order_id).then((e) => {
  //     if (!e.data.errors) {
  //       setRace(e.data.data?.race);
  //       setElement(e?.data.data.product);
  //       setOrder(e?.data.data);
  //     }
  //   });
  // }, []);

  let styleCard = {};
  let classCard = "card h-100";
  if (props.dashboard === false) {
    styleCard = { minHeight: "var(--clientheight)" };
    classCard = "card border-0";
  }

  return (
    <div className={classCard} style={styleCard}>
    {/* <CardHeaderDashboardOnOff loading={loading} switchClick={switchClick} onClick={handleClickMC}  defCheck={onoff}>
        Доступность Компонентов МС
    </CardHeaderDashboardOnOff> */}
  
      <MainAreaHeader caption="Состояние системы" />

    <div className="card-body" style={{ fontSize: "0.85rem" }}>
        {(
            servicesMC.map((item, index, array) => {
                return (
                    <div key={item.id} className={`gap-2 col-12 d-flex align-items-center column-mc ${index == 0 ? "" : "mt-1"}`}>
                        <div>
                            <span className="link-info">
                                {item.href ? <a className="link-info" href={`${item.href}`}>{item.name}</a> : item.name} 
                                {/* - <small>{moment(item.date).isValid() ? moment.utc(item.date).local().format("DD.MM.YYYY HH:mm:ss") : item.date}</small> */}
                            </span>
                        </div>
                        <div className="line-mc">
                        {loadingStatus ? (
                          <>
                          <div className="el-line-mc">
                            <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                            <div>Работоспособность</div>
                          </div>
                          <div className="el-line-mc">
                            <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                            <div>Исправность</div>
                          </div>
                          </>
                        ) : (
                          <>
                              <div className="el-line-mc">
                              <i className={`fs-5 ${item.status === "normal" ? "bi-check-circle-fill text_green" : (item.status == "failed" || item.status == "missing") ? "bi-x-circle-fill text-danger" : "bi-check-circle-fill text_yellow"}`}></i>
                              <div>Работоспособность</div>
                              </div>
                                <div className="el-line-mc">
                                <i className={`fs-5 ${item.is_used === "normal" ? "bi-check-circle-fill text_green" : (item.is_used == "failed" || item.is_used == "missing") ? "bi-x-circle-fill text-danger" : "bi-check-circle-fill text_yellow"}`}></i>
                                <div>Исправность</div>
                                </div>
                          </>
                        )}
                        </div>
                    </div>
                );
            })
        )}
        <div className="lower-line">
          <div className="text-cont">
            <div className="text">Состояние актуально на:</div>
            <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
          </div>
          <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
        </div>

    </div>
</div>
// </>
  );
}

export default CardSystems;